
import React, { useState, useEffect } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams, Link } from "react-router-dom";


import {
    updateConvenienceAndCharge,
    getConvenienceAndChargeId,
    createPriceFareRule,
    getPriceFareRuleId,
    updatePriceFareRule
} from "../../services/userservice";

import { setEditingCategory, setEditingCategoryId, setError, setLoading } from "../../features/common/categorySlice";


const AddPriceFareRuleList = () => {
    const { id } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [isEditMode, setIsEditMode] = useState(false);
    const { loading, error, editingCategory } = useSelector((state) => state.category);

    const [showModal, setShowModal] = useState(false);
    const [formData, setFormData] = useState([
        {
            title: "", discount_type: "", value: "", category: "", status: ""
        },
    ]);


    useEffect(() => {
        if (id && id !== "add" && editingCategory !== id) {
            dispatch(setEditingCategoryId(id));
            dispatch(setEditingCategory(id));
            setIsEditMode(true);
            fetchUserData(id);
        }
    }, [id, editingCategory, dispatch]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const formDataToSend = {
                ...formData,
            };
            dispatch(setLoading(true));
            const response =
                id && id !== "add"
                    ? await updatePriceFareRule(id, formDataToSend)
                    : await createPriceFareRule(formDataToSend);
            navigate("/price-fare-rule");
            console.log("response", response)
        } catch (error) {
            dispatch(setError(error.message));
            alert(error.message);

            dispatch(setLoading(false));
        }
    };

    const fetchUserData = async (id) => {
        try {
            dispatch(setLoading());
            const response = await getPriceFareRuleId(id);
            if (response) {
                const responseData = response;
                setFormData({
                    title: responseData?.title,
                    discount_type: responseData?.discount_type,
                    value: responseData?.value,
                    status: responseData?.status,
                    category: responseData?.category
                });
                dispatch(setLoading(false));
            }
        } catch (error) {
            dispatch(setError(error.message));
        } finally {
            dispatch(setLoading(false));
        }
    };


    const handleInputChange = (event) => {
        const { name, value } = event.target;

        if (name === "discount_type") {
            setFormData({
                ...formData,
                [name]: value,
                value: "",
            });
        } else {
            let newValue = value;

            if (formData.discount_type === "PERCENTAGE") {
                if (newValue > 100) {
                    return;
                }
            } else if (formData.discount_type === "AMOUNT") {
                if (newValue > 1000) {
                    return;
                }
            }
            setFormData({
                ...formData,
                [name]: newValue,
            });
        }
    };


    return (
        <div className="content-wrapper">
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1 className="m-0">Add Price Fare Rule</h1>
                        </div>

                        <div className="col-sm-6">
                            <ol className="breadcrumb float-sm-right">
                                <li className="breadcrumb-item">
                                    <Link to="/dashboard">Home</Link>
                                </li>
                                <li className="breadcrumb-item active">Add Price Fare Rule</li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>

            <section className="content">
                <div className="container-fluid">
                    <div classname="row">
                        <div className="col-md-12">
                            <form onSubmit={handleSubmit}>
                                <div className="card">
                                    <div className="card-body">
                                        <div className="row">

                                            <div className="col-sm-6">
                                                <div className="form-group">
                                                    <label htmlFor="exampleInputEmail1">Price Fare Rule Title</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        id="exampleInputEmail1"
                                                        placeholder="Enter Price Fare Rule Title"
                                                        name="title"
                                                        value={formData.title}
                                                        onChange={handleInputChange}
                                                    />
                                                </div>
                                            </div>

                                            <div className="col-sm-6">
                                                <div className="form-group">
                                                    <label htmlFor="exampleInputEmail1">Discount Type</label>
                                                    <select
                                                        className="form-control"
                                                        id="discountType"
                                                        name="discount_type"
                                                        value={formData.discount_type}
                                                        onChange={handleInputChange}
                                                    >
                                                        <option value="">Select</option>
                                                        <option value="PERCENTAGE">PERCENTAGE</option>
                                                        <option value="AMOUNT">AMOUNT</option>
                                                    </select>
                                                </div>
                                            </div>


                                            <div className="col-sm-6">
                                                <div className="form-group">
                                                    <label htmlFor="exampleInputEmail1">Value</label>
                                                    <input
                                                        type="number"
                                                        className="form-control"
                                                        id="value"
                                                        placeholder="Enter Value"
                                                        name="value"
                                                        value={formData.value}
                                                        onChange={handleInputChange}
                                                    />
                                                </div>
                                            </div>

                                            <div className="col-sm-6">
                                                <div className="form-group">
                                                    <label>Category</label>
                                                    <select
                                                        className="form-control"
                                                        id="category"
                                                        name="category"
                                                        value={formData.category}
                                                        onChange={handleInputChange}
                                                    >
                                                        <option value="">Select Category</option>
                                                        <option value="flight">FLIGHT</option>
                                                        <option value="hotel">HOTEL</option>
                                                    </select>
                                                </div>
                                            </div>

                                            <div className="col-sm-6">
                                                <div className="form-group">
                                                    <label>Status</label>
                                                    <select
                                                        className="form-control"
                                                        id="status"
                                                        name="status"
                                                        value={formData.status}
                                                        onChange={handleInputChange}
                                                    >
                                                        <option value="">Select</option>
                                                        <option value="active">Active</option>
                                                        <option value="inactive">Inactive</option>
                                                    </select>
                                                </div>
                                            </div>

                                        </div>


                                    </div>
                                    <div class="card-footer">
                                        <button type="submit" className="btn btn-primary">
                                            Submit
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </section>




        </div>
    );
};

export default AddPriceFareRuleList;